var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuiltInWardrobes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1475 5H6.85222C6.32371 5 5.89478 5.42862 5.89478 5.95745V31.1096V35H7.80967V32.067H32.1901V35H34.105V31.1096V5.95745C34.105 5.42862 33.6767 5 33.1475 5ZM18.8915 13.9569H7.80967V11.1372H18.8915V13.9569ZM18.8915 15.8718V18.6915H7.80967V15.8718H18.8915ZM20.8061 6.91489H32.1901V30.1521H20.8061V6.91489ZM18.8915 6.91489V9.22234H7.80967V6.91489H18.8915ZM7.80967 20.6064H18.8915V30.1518H7.80967V20.6064Z",
    fill: "#2A3842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1444 22.6418H11.5571V24.5567H15.1444V22.6418Z",
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltInWardrobes);
export default __webpack_public_path__ + "static/media/builtInWardrobes.1923de3e1a5fcaa3a868ca9a06e0ee9a.svg";
export { ForwardRef as ReactComponent };